import React from 'react';

import Icon, { IconProps } from '../../icon';
import useStyles from './styles';

export const Plus = (): string => {
  const classes = useStyles();
  return classes.plus;
};

export const PlusIcon = (props: IconProps): JSX.Element => {
  const classes = useStyles();
  return <Icon icon={classes.plus} {...props} />;
};
